
export class VisionLinesStat {
id: number | null;
nbLines: number | null;
stepLevel: number | null;
visionCode: string;
}

